import { useState } from 'react';
import type { FC } from 'react';

function defaultFrom(): string {
  const d = new Date();
  d.setMonth(d.getMonth() - 1);
  return d.toISOString().slice(0, 10);
}

function defaultTo(): string {
  return new Date().toISOString().slice(0, 10);
}

interface DateRangePickerProps {
  onFetch: (fromISO: string, toISO: string) => void;
  loading?: boolean;
  children?: React.ReactNode;
}

const DateRangePicker: FC<DateRangePickerProps> = ({ onFetch, loading, children }) => {
  const [from, setFrom] = useState(defaultFrom);
  const [to, setTo] = useState(defaultTo);

  const handleFetch = () => {
    onFetch(`${from}T00:00:00.000Z`, `${to}T23:59:59.999Z`);
  };

  return (
    <div className="d-flex align-items-center gap-2 mb-2 flex-wrap">
      <input type="date" className="form-control form-control-sm" style={{ width: 130 }} value={from} onChange={e => setFrom(e.target.value)} />
      <span className="text-muted small">to</span>
      <input type="date" className="form-control form-control-sm" style={{ width: 130 }} value={to} onChange={e => setTo(e.target.value)} />
      <button className="btn btn-primary btn-sm" onClick={handleFetch} disabled={loading}>
        {loading ? '...' : 'Fetch'}
      </button>
      {children}
    </div>
  );
};

export default DateRangePicker;
